import { render, staticRenderFns } from "./file_notice_list.vue?vue&type=template&id=da0e60b0&scoped=true&"
import script from "./file_notice_list.vue?vue&type=script&lang=js&"
export * from "./file_notice_list.vue?vue&type=script&lang=js&"
import style0 from "./file_notice_list.vue?vue&type=style&index=0&id=da0e60b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0e60b0",
  null
  
)

export default component.exports